import { CreateTrustModel, TrustModel, UpdateTrustModel } from 'Pages/ibro'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { RequestParams, ResponseCatalog } from 'Models'
import { serialize } from 'object-to-formdata'

export const trustApi = {
	getAll: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<TrustModel>>(urls.broker.settings.trust, {
			params,
		})

		return res.data
	},
	createOne: async (data: CreateTrustModel) => {
		const formData = serialize({ data })
		const res = await axiosDS().post<TrustModel>(urls.broker.settings.trust, formData)
		return res.data
	},
	updateOne: async (data: UpdateTrustModel) => {
		const res = await axiosDS().patch<TrustModel>(`${urls.broker.settings.trust}/${data.id}`, {
			data,
		})
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.broker.settings.trust}/${id}`)
		return res.data
	},
}
